import React, {useEffect, useState} from 'react';
import {NavLink} from 'react-router-dom';

import {appSetModalContent} from "../redux/app/appActions";
import {useDispatch} from "react-redux";
import DynamicContainerLayout from "../components/construct/layout/DynamicContainer";
import {dataAddFilter, dataRemoveFilter, filterUpdateConditionAction} from "../redux/data/dataActions";
import i18n from 'i18next';
import { axiosBaseURL } from '../config/config';

// Material UI Icons
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import AssessmentIcon from "@mui/icons-material/Assessment";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import AppsIcon from "@mui/icons-material/Apps";
import BorderClearIcon from "@mui/icons-material/BorderClear";
import CameraIcon from "@mui/icons-material/Camera";
import CasinoIcon from "@mui/icons-material/Casino";
import CategoryIcon from "@mui/icons-material/Category";
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import CreditCardIcon from "@mui/icons-material/CreditCard";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import DashboardIcon from "@mui/icons-material/Dashboard";
import DescriptionIcon from '@mui/icons-material/Description';
import DeviceHubIcon from '@mui/icons-material/DeviceHub';
import EditIcon from '@mui/icons-material/Edit';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import EventNoteIcon from "@mui/icons-material/EventNote";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import ExtensionIcon from "@mui/icons-material/Extension";
import FilterFramesIcon from "@mui/icons-material/FilterFrames";
import FunctionsIcon from '@mui/icons-material/Functions';
import GroupIcon from "@mui/icons-material/Group";
import HealingIcon from "@mui/icons-material/Healing";
import InfoIcon from '@mui/icons-material/Info';
import LinkIcon from "@mui/icons-material/Link";
import ListIcon from "@mui/icons-material/List";
import HomeIcon from "@mui/icons-material/Home";
import MapIcon from "@mui/icons-material/Map";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import NotesIcon from "@mui/icons-material/Notes";
import NotificationImportantIcon from "@mui/icons-material/NotificationImportant";
import PageviewIcon from '@mui/icons-material/Pageview';
import PeopleIcon from "@mui/icons-material/People";
import Person from "@mui/icons-material/Person";
import PostAddIcon from "@mui/icons-material/PostAdd";
import PowerIcon from "@mui/icons-material/Power";
import PrintIcon from '@mui/icons-material/Print';
import QueueIcon from "@mui/icons-material/Queue";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import ScheduleIcon from '@mui/icons-material/Schedule';
import SecurityIcon from "@mui/icons-material/Security";
import SettingsIcon from "@mui/icons-material/Settings";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import StarIcon from "@mui/icons-material/Star";
import StarsIcon from "@mui/icons-material/Stars";
import SystemUpdateAltIcon from "@mui/icons-material/SystemUpdateAlt";
import SystemUpdateIcon from "@mui/icons-material/SystemUpdateAlt";
import ThunderstormIcon from "@mui/icons-material/Thunderstorm";
import TimelineIcon from "@mui/icons-material/Timeline";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import ViewComfyIcon from "@mui/icons-material/ViewComfy";
import ViewQuiltIcon from "@mui/icons-material/ViewQuilt";
import WallpaperIcon from "@mui/icons-material/Wallpaper";
import WarningIcon from "@mui/icons-material/Warning";
import HubIcon from '@mui/icons-material/Hub';
import EPASWMMIcon from '../styles/images/epaswmm5.png';

import {
    Avatar,
    List,
    ListItem,
    ListItemAvatar,
    ListItemIcon,
    ListItemText,
    Tooltip,
} from '@mui/material';
import ShowPercentCompleteIcon from "../styles/images/ShowPercentCompleteButton.png";

export const formatIcon = (input, config) => {

    // Console logging flag
    const logToConsole = false;

    // *************** CONFIG OPTIONS ***************

    // **********************************************

    let output = <React.Fragment></React.Fragment>;

	if (input) {
		switch (input.toLowerCase()) {
			case 'accountbalanceicon':
				// Contract Costs, Contract Cost Trends
				output = <AccountBalanceIcon
					style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'accountbalancewallet':
				// Cost Report - Contract Costs, Cost Trends
				output = <AccountBalanceWalletIcon
					style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'accounttreeicon':
				// Project Tree
				output =
					<AccountTreeIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'addphotoalternateicon':
				// Project Images
				output = <AddPhotoAlternateIcon
					style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'appsicon':
				// Matrix Projects
				output = <AppsIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'assessmenticon':
				// KPI
				output =
					<AssessmentIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'assignmentturnedinicon':
				// Tasks
				output = <AssignmentTurnedInIcon
					style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'borderclearicon':
				// Matrix Positions
				output =
					<BorderClearIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'cameraicon':
				// 360
				output = <CameraIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'casinoicon':
				// Security > Roles
				output = <CasinoIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'categoryicon':
				// Task Categories
				output =
					<CategoryIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'contactmailicon':
				// Home Contacts
				output =
					<ContactMailIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'createnewfoldericon':
				// Create New Folder
				output =
					<CreateNewFolderIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'creditcardicon':
				// Costs
				output =
					<CreditCardIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'dashboardicon':
				// Dashboard
				output =
					<DashboardIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'descriptionicon':
				// Description
				output =
					<DescriptionIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'devicehubicon':
				// Device Hub
				output =
					<DeviceHubIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'emojipeopleicon':
				// TODO: Stakeholders ???
				output =
					<EmojiPeopleIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'epaswmmicon':
				output = <img src={EPASWMMIcon} style={{height: config?.fontSize !== undefined ? '40px' : null, width: config?.fontSize !== undefined ? '40px': null }}/>;
				break;
			case 'eventnoteicon':
				// Schedule
				output =
					<EventNoteIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'extensionicon':
				// Project Extension
				output =
					<ExtensionIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'filterframesicon':
				// Model Types
				output = <FilterFramesIcon
					style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'functionsicon':
				// TODO: Engineering ???
				output =
					<FunctionsIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'groupicon':
				// Staffing, Security > Users
				output = <GroupIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'healingicon':
				// HSE
				output =
					<HealingIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'homeicon':
				// Home
                output = <HomeIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
                break;
            case 'hubicon':
                // Hub
                output = <HubIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
                break;
			case 'linkicon':
				// Home Links
				output = <LinkIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'listicon':
				// Home Links
				output = <ListIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'mapicon':
				// Map
				output = <MapIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'noteaddicon':
				// Project Status
				output =
					<NoteAddIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'notesicon':
				// Task Reports
				output = <NotesIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'notificationimportanticon':
				// Issues
				output = <NotificationImportantIcon
					style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'pageviewicon':
				// TODO: Quality ???
				output =
					<PageviewIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'peopleicon':
				// Task Resources
				output = <PeopleIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'postaddicon':
				// Project Metadata
				output =
					<PostAddIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'powericon':
				// Project Metadata
				output = <PowerIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'printicon':
				// Reports
				output = <PrintIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'questionanswericon':
				// Matrix Questions
				output = <QuestionAnswerIcon
					style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'queueicon':
				// Projects
				output = <QueueIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'scheduleicon':
				// TODO: Time ???
				output =
					<ScheduleIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'securityicon':
				// Security
				output =
					<SecurityIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'settingsicon':
				// Settings
				output =
					<SettingsIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'shoppingcarticon':
				// TODO: Procurement ???
				output = <ShoppingCartIcon
					style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'staricon':
				// Security > Features
				output = <StarIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'starsicon':
				// Project Notes
				output = <StarsIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'systemupdateicon':
				// Loaders ???
				output = <SystemUpdateIcon
					style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'thunderstormicon':
				output =
					<ThunderstormIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'timelineicon':
				output =
					<TimelineIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'trendingupicon':
				// Project Trends
				output =
					<TrendingUpIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'viewcomfyicon':
				// Portfolio
				output =
					<ViewComfyIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'viewquilticon':
				// Details
				output =
					<ViewQuiltIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'warningicon':
				// Risks, Risk Actual Costs, Risk Mitigation Actions
				// Risk Treatments, Risk Model Results
				output =
					<WarningIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			case 'wallpapericon':
				// Home Images
				output =
					<WallpaperIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
				break;
			default:
				output =
					<SettingsIcon style={{fontSize: config?.fontSize !== undefined ? config.fontSize : 'x-large'}}/>;
		}
	}
    // Console logging
    if (logToConsole) {
        console.log(
            '%c formatIcon', 'font-weight: bold; color: none',
            '\n' + ' - input.typeof:', typeof input,
            '\n' + ' - config.typeof:', typeof config,
            '\n' + ' - output.typeof:', typeof output + '\n',
            { input },
            { config },
            { output }
        );
    }

    return output;
}

export const formatAvatar = (input, config) => {

    // Console logging flag
    const logToConsole = false;

    // *************** CONFIG OPTIONS ***************
    // content(string) : image | initials : default = image
    // variant(string) : circular | rounded | square : default = rounded
    // **********************************************

    // Set defaults
    let content, variant;
    if (config instanceof Object) {
        content = typeof config.content === 'string' ? config.content.toLowerCase() : 'image';
        variant = typeof config.variant === 'string' ? config.variant : 'rounded';
    } else {
        content = 'image';
        variant = 'rounded';
    }

    // NOTE: Obviously this will need to be changed to accommodate more than what's assumed here
    let firstName;
    let lastName;
    if (input !== null) {
        const inputParts = input.split(" ");
        firstName = inputParts[0];
        lastName = inputParts[1];
    } else {
        firstName = "";
        lastName = "";
    }

    // Avatar Content
    let avatarContent;
    if (content === 'initials') {
        const firstInitial = firstName.substring(0, 1);
        const lastInitial = lastName.substring(0, 1);
        avatarContent = firstInitial + lastInitial;
        // console.log(' > First initial: {0}; Last initial: {1}'.format(firstInitial, lastInitial));
    } else if (content === 'image') {
        avatarContent = <Person />;
    } else {

    }

    // console.log(' > Avatar content: {0} ({1})'.format(avatarContent, typeof avatarContent));
    // console.log(' > Variant: {0} ({1})'.format(variant, typeof variant));

    const output = <List style={{padding: '0'}}><ListItem style={{padding: '0'}}><ListItemAvatar><Avatar variant={variant}>{avatarContent}</Avatar></ListItemAvatar><ListItemText primaryTypographyProps={{variant: 'body2'}} primary={firstName} secondaryTypographyProps={{variant: 'body2'}} secondary={lastName} /></ListItem></List>

    // Console logging
    if (logToConsole) {
        console.log(
            '%c formatAvatar', 'font-weight: bold; color: none',
            '\n' + ' - input.typeof:', typeof input,
            '\n' + ' - config.typeof:', typeof config,
            '\n' + ' - output.typeof:', typeof output + '\n',
            { input },
            { config },
            { output }
        );
    }

    return output;
}

export const formatDate = (input, config) => {

    // Console logging flag
    const logToConsole = false;

    // *************** CONFIG OPTIONS ***************
    // default(string) : default = '-'
    // variant(string) : m/d/yyyy | MON YYYY : default = m/d/yyyy
    // **********************************************

    // Set defaults
    let defaultValue, variant;
    if (config instanceof Object) {
        defaultValue = typeof config.default === 'string' ? config.default : '-';
        variant = typeof config.variant === 'string' ? config.variant.toLowerCase() : 'm/d/yyyy';
    } else {
        defaultValue = '-';
        variant = 'm/d/yyyy';
    }

    let output;
    if (input) {
        // If INPUT is a STRING, check if UTC time, else convert to UTC time
        let inputAsDate = input instanceof Date ? input : (input.toString().indexOf(':') >= 0 ? new Date(input) : new Date(input+'T00:00'));

        // Check if Conversion failed...possible fail if adding the UTC time
        if (isNaN(inputAsDate)) {
            inputAsDate = new Date(input);
        }

        // Other things from DateUtilities
        // console.log(' > ', inputAsDate.getUTCFullYear());
        // console.log(' > ', (inputAsDate.getMonth() + 1) + '/' + inputAsDate.getDate() + '/' + inputAsDate.getFullYear() + ' ' + inputAsDate.toLocaleTimeString());

        // Variant
        // console.log('VARIANT: {0}'.format(variant));
        if (variant.toLowerCase() === 'm/d/yyyy') {
            output = (inputAsDate.getMonth() + 1) + '/' + inputAsDate.getDate() + '/' + inputAsDate.getFullYear();
        } else if (variant.toLowerCase() === 'd/m/yyyy') {
            output = inputAsDate.getDate() + '/' + (inputAsDate.getMonth() + 1) + '/' + inputAsDate.getFullYear();
        } else if (variant.toLowerCase() === 'dd/mm/yyyy') {
            let dd = inputAsDate.getDate();
            let mm = inputAsDate.getMonth()+1;
            let yyyy = inputAsDate.getFullYear();
            if(dd<10)
            {
                dd='0'+dd;
            }
            if(mm<10)
            {
                mm='0'+mm;
            }
            output = dd + '/' + mm + '/' + yyyy;
        } else if (variant.toLowerCase() === 'dd/mm/yyyy time') {
            let dd = inputAsDate.getDate();
            let mm = inputAsDate.getMonth()+1;
            let yyyy = inputAsDate.getFullYear();
            if(dd<10)
            {
                dd='0'+dd;
            }
            if(mm<10)
            {
                mm='0'+mm;
            }
            let hh = inputAsDate.getHours();
            let mins = inputAsDate.getMinutes();
            let secs = inputAsDate.getSeconds();
            let milli = inputAsDate.getMilliseconds();
            output = dd + '/' + mm + '/' + yyyy + ' ' + hh + ':' + mins + ':' + secs + '.' + milli;
        } else if (variant.toLowerCase() === 'm/yy') {
            output = (inputAsDate.getMonth() + 1) + '/' + inputAsDate.getFullYear().toString().substr(-2);
        } else if (variant.toLowerCase() === 'mm/dd/yyyy') {
            let dd = inputAsDate.getDate();
            let mm = inputAsDate.getMonth()+1;
            let yyyy = inputAsDate.getFullYear();
            if(dd<10)
            {
                dd='0'+dd;
            }
            if(mm<10)
            {
                mm='0'+mm;
            }
            output = mm + '/' + dd + '/' + yyyy;
        } else if (variant.toLowerCase() === 'mon yyyy') {
            output = inputAsDate.toLocaleString('en-US', {month: 'short'}) + ' ' + inputAsDate.getFullYear();
        } else if (variant.toLowerCase() === 'mm/dd/yyyy time') {
            let dd = inputAsDate.getDate();
            let mm = inputAsDate.getMonth()+1;
            let yyyy = inputAsDate.getFullYear();
            if(dd<10)
            {
                dd='0'+dd;
            }
            if(mm<10)
            {
                mm='0'+mm;
            }
            let hh = inputAsDate.getHours();
            let mins = inputAsDate.getMinutes();
            let secs = inputAsDate.getSeconds();
            let milli = inputAsDate.getMilliseconds();
            output = mm + '/' + dd + '/' + yyyy + ' ' + hh + ':' + mins + ':' + secs + '.' + milli;
        } else {
            output = inputAsDate;
        }
    } else {
        output = defaultValue;
    }

    // Console logging
    if (logToConsole) {
        console.log(
            '%c formatDate', 'font-weight: bold; color: none',
            '\n' + ' - input.typeof:', typeof input,
            '\n' + ' - config.typeof:', typeof config,
            '\n' + ' - output.typeof:', typeof output + '\n',
            { input },
            { config },
            { output }
        );
    }

    return output;
}

export const formatDuration = (start, finish, config) => {

    // Console logging flag
    const logToConsole = false;

    // *************** CONFIG OPTIONS ***************
    // default(string) : default = '-'
    // variant(string) : seconds | minutes | hours | days | weeks | months | monthdays | years | yearmonth : default: yearmonth
    // **********************************************

    // DEFAULTS
    // let defaultValue,
    let variant;
    if (config instanceof Object) {
        // defaultValue = typeof config.default === 'string' ? config.default : '-';
        variant = typeof config.variant === 'string' ? config.variant.toUpperCase() : 'yearmonth';
    } else {
        // defaultValue = '-';
        variant = 'yearmonth';
    }

    let numberConfig;
    if (config?.numberFormatter !== undefined) {
        numberConfig = config.numberFormatter;
    } else {
        switch (variant) {
            case "DAYS":
            case "WEEKS":
            case "MONTHS":
            case "YEARS":
                numberConfig = {"abbreviate": false, "addSeparators": true, "currency": false, "decimals": 0, "default": "--", "fixDecimals": true, "round": true};
                break;
            case "SECONDS":
            case "MINUTES":
            case "HOURS":
                numberConfig = {"abbreviate": true, "addSeparators": false, "currency": false, "decimals": 1, "default": "--", "fixDecimals": true, "round": true};
                break;
            default:
                numberConfig = {"abbreviate": false, "addSeparators": true, "currency": false, "decimals": 0, "default": "--", "fixDecimals": true, "round": true};
        }
    }

    const date1 = start instanceof Date ? start : new Date(start);
    const date2 = finish instanceof Date ? finish : new Date(finish);

    // https://www.educative.io/edpresso/mathceil-mathfloor-and-mathround-in-javascript
    // Math.floor ==> Round Down
    // const diffSeconds = Math.floor( ( date2 - date1) / 1000 );
    // const diffMinutes = Math.floor( diffSeconds / 60 );
    // const diffHours = Math.floor( diffMinutes / 60 );
    // const diffDays = Math.floor( diffHours / 24 );
    // const diffWeeks = Math.ceil(diffDays / 7);
    // const diffYears = date2.getFullYear() - date1.getFullYear();
    // const diffMonths = (diffYears * 12) + (date2.getMonth() - date1.getMonth()) ;

    // Math.Round ==> Greater than half day, round up; Less than half day, round down
    const diffSeconds = Math.round( ( date2 - date1) / 1000 );
    const diffMinutes = Math.round( diffSeconds / 60 );
    const diffHours = Math.round( diffMinutes / 60 );
    const diffDays = Math.round( diffHours / 24 );
    const diffWeeks = Math.ceil(diffDays / 7);
    const diffYears = date2.getFullYear() - date1.getFullYear();
    const diffMonths = (diffYears * 12) + (date2.getMonth() - date1.getMonth()) ;

    // console.log('DIFFERENCE (SECONDS): {0} ({1})'.format(diffSeconds, typeof diffSeconds));
    // console.log('DIFFERENCE (MINUTES): {0} ({1})'.format(diffMinutes, typeof diffMinutes));
    // console.log('DIFFERENCE (HOURS): {0} ({1})'.format(diffHours, typeof diffHours));
    // console.log('DIFFERENCE (DAYS): {0} ({1})'.format(diffDays, typeof diffDays));
    // console.log('DIFFERENCE (WEEKS): {0} ({1})'.format(diffWeeks, typeof diffWeeks));
    // console.log('DIFFERENCE (MONTHS): {0} ({1})'.format(diffMonths, typeof diffMonths));
    // console.log('DIFFERENCE (YEARS): {0} ({1})'.format(diffYears, 'typeof diffYears));

    let output = null;
    if (variant === 'SECONDS') {
        output = formatNumber(diffSeconds, numberConfig) + ' seconds';
    } else if (variant === 'MINUTES') {
        output = formatNumber(diffMinutes, numberConfig) + ' minutes';
    } else if (variant === 'HOURS') {
        output = formatNumber(diffHours, numberConfig) + ' hours';
    } else if (variant === 'DAYS') {
        output = formatNumber(diffDays, numberConfig) + ' days';
    } else if (variant === 'WEEKS') {
        output = formatNumber(diffWeeks, numberConfig) + ' weeks';
    } else if (variant === 'MONTHS') {
        output = formatNumber(diffMonths, numberConfig) + ' months';
    } else if (variant === 'YEARS') {
        output = formatNumber(diffYears, numberConfig) + ' years';
    } else if (variant === 'YEARMONTH') {

        const diff = new Date(date2 - date1);
        const diffYear2 = diff.getUTCFullYear() - 1970;
        const diffMonth2 = diff.getUTCMonth();

        if (diffYear2 === 0) {
            if (diffMonth2 === 1) {
                output = diffMonth2 + ' month';
            } else {
                output = diffMonth2 + ' months';
            }
        }
        else if (diffYear2 === 1) {
            if (diffMonth2 === 0) {
                output = diffYear2 + ' year';
            }
            else if (diffMonth2 === 1) {
                output = diffYear2 + ' year, ' + diffMonth2 + ' month';
            } else {
                output = diffYear2 + ' year, ' + diffMonth2 + ' months';
            }
        }
        else {
            if (diffMonth2 === 0) {
                output = diffYear2 + ' years';
            }
            else if (diffMonth2 === 1) {
                output = diffYear2 + ' years, ' + diffMonth2 + ' month';
            } else {
                output = diffYear2 + ' years, ' + diffMonth2 + ' months';
            }
        }
    } else if (variant === 'MONTHDAYS') {

        const diff = new Date(date2 - date1);
        const diffYear2 = diff.getUTCFullYear() - 1970;
        const diffMonth2 = diff.getUTCMonth();
        const diffDays2 = diff.getUTCDay();

        if (diffYear2 === 0) {
            if (diffMonth2 === 1) {
                output = diffDays2 + ' days';
            } else {
                output = diffMonth2 + ' months, ' + diffDays2 + ' days';
            }
        }
        else if (diffYear2 === 1) {
            if (diffMonth2 === 0) {
                output = diffYear2 + ' year';
            }
            else if (diffMonth2 === 1) {
                output = diffYear2 + ' year, ' + diffMonth2 + ' month, ' + diffDays2 + ' days';
            } else {
                output = diffYear2 + ' year, ' + diffMonth2 + ' months, ' + diffDays2 + ' days';
            }
        }
        else {
            if (diffMonth2 === 0) {
                output = diffYear2 + ' years';
            }
            else if (diffMonth2 === 1) {
                output = diffYear2 + ' years, ' + diffMonth2 + ' month, ' + diffDays2 + ' days';
            } else {
                output = diffYear2 + ' years, ' + diffMonth2 + ' months, ' + diffDays2 + ' days';
            }
        }
    } else {

    }

    // Console logging
    if (logToConsole) {
        console.log(
            '%c formatDuration', 'font-weight: bold; color: none',
            '\n' + ' - start.typeof:', typeof start,
            '\n' + ' - finish.typeof:', typeof finish,
            '\n' + ' - config.typeof:', typeof config,
            '\n' + ' - output.typeof:', typeof output + '\n',
            { start },
            { finish },
            { config },
            { output }
        );
    }

    return output;
}

export const formatDaysRemaining = (finish, config) => {

    // Console logging flag
    const logToConsole = false;

    // *************** CONFIG OPTIONS ***************
    // default(string) : default = '-'
    // variant(string) : seconds | minutes | hours | days | weeks | months | years | yearmonth : default: yearmonth
    // **********************************************

    let currDate = new Date();

    // DEFAULTS
    // let defaultValue,
    let variant;
    if (config instanceof Object) {
        // defaultValue = typeof config.default === 'string' ? config.default : '-';
        variant = typeof config.variant === 'string' ? config.variant.toUpperCase() : 'yearmonth';
    } else {
        // defaultValue = '-';
        variant = 'yearmonth';
    }

    let numberConfig;
    if (config?.numberFormatter !== undefined) {
        numberConfig = config.numberFormatter;
    } else {
        switch (variant) {
            case "DAYS":
            case "WEEKS":
            case "MONTHS":
            case "YEARS":
                numberConfig = {"abbreviate": false, "addSeparators": true, "currency": false, "decimals": 0, "default": "--", "fixDecimals": true, "round": true};
                break;
            case "SECONDS":
            case "MINUTES":
            case "HOURS":
                numberConfig = {"abbreviate": true, "addSeparators": false, "currency": false, "decimals": 1, "default": "--", "fixDecimals": true, "round": true};
                break;
            default:
                numberConfig = {"abbreviate": false, "addSeparators": true, "currency": false, "decimals": 0, "default": "--", "fixDecimals": true, "round": true};
        }
    }

    const date2 = finish instanceof Date ? finish : new Date(finish);

    // https://www.educative.io/edpresso/mathceil-mathfloor-and-mathround-in-javascript
    // Math.floor ==> Round Down
    // const diffSeconds = Math.floor( ( date2 - currDate) / 1000 );
    // const diffMinutes = Math.floor( diffSeconds / 60 );
    // const diffHours = Math.floor( diffMinutes / 60 );
    // const diffDays = Math.floor( diffHours / 24 );
    // const diffWeeks = Math.ceil(diffDays / 7);
    // const diffYears = date2.getFullYear() - currDate.getFullYear();
    // const diffMonths = (diffYears * 12) + (date2.getMonth() - currDate.getMonth()) ;

    // Math.Round ==> Greater than half day, round up; Less than half day, round down
    const diffSeconds = Math.round( ( date2 - currDate) / 1000 );
    const diffMinutes = Math.round( diffSeconds / 60 );
    const diffHours = Math.round( diffMinutes / 60 );
    const diffDays = Math.round( diffHours / 24 );
    const diffWeeks = Math.ceil(diffDays / 7);
    const diffYears = date2.getFullYear() - currDate.getFullYear();
    const diffMonths = (diffYears * 12) + (date2.getMonth() - currDate.getMonth()) ;

    // console.log('DIFFERENCE (SECONDS): {0} ({1})'.format(diffSeconds, typeof diffSeconds));
    // console.log('DIFFERENCE (MINUTES): {0} ({1})'.format(diffMinutes, typeof diffMinutes));
    // console.log('DIFFERENCE (HOURS): {0} ({1})'.format(diffHours, typeof diffHours));
    // console.log('DIFFERENCE (DAYS): {0} ({1})'.format(diffDays, typeof diffDays));
    // console.log('DIFFERENCE (WEEKS): {0} ({1})'.format(diffWeeks, typeof diffWeeks));
    // console.log('DIFFERENCE (MONTHS): {0} ({1})'.format(diffMonths, typeof diffMonths));
    // console.log('DIFFERENCE (YEARS): {0} ({1})'.format(diffYears, 'typeof diffYears));

    let output = null;
    if (variant === 'SECONDS') {
        output = formatNumber(diffSeconds, numberConfig) + ' seconds';
    } else if (variant === 'MINUTES') {
        output = formatNumber(diffMinutes, numberConfig) + ' minutes';
    } else if (variant === 'HOURS') {
        output = formatNumber(diffHours, numberConfig) + ' hours';
    } else if (variant === 'DAYS') {
        output = formatNumber(diffDays, numberConfig) + ' days';
    } else if (variant === 'WEEKS') {
        output = formatNumber(diffWeeks, numberConfig) + ' weeks';
    } else if (variant === 'MONTHS') {
        output = formatNumber(diffMonths, numberConfig) + ' months';
    } else if (variant === 'YEARS') {
        output = formatNumber(diffYears, numberConfig) + ' years';
    } else if (variant === 'YEARMONTH') {

        const diff = new Date(date2 - currDate);
        const diffYear2 = diff.getUTCFullYear() - 1970;
        const diffMonth2 = diff.getUTCMonth();

        if (diffYear2 === 0) {
            if (diffMonth2 === 1) {
                output = diffMonth2 + ' month';
            } else {
                output = diffMonth2 + ' months';
            }
        }
        else if (diffYear2 === 1) {
            if (diffMonth2 === 0) {
                output = diffYear2 + ' year';
            }
            else if (diffMonth2 === 1) {
                output = diffYear2 + ' year, ' + diffMonth2 + ' month';
            } else {
                output = diffYear2 + ' year, ' + diffMonth2 + ' months';
            }
        }
        else {
            if (diffMonth2 === 0) {
                output = diffYear2 + ' years';
            }
            else if (diffMonth2 === 1) {
                output = diffYear2 + ' years, ' + diffMonth2 + ' month';
            } else {
                output = diffYear2 + ' years, ' + diffMonth2 + ' months';
            }
        }
    } else if (variant === 'MONTHDAYS') {

        const diff = new Date(date2 - currDate);
        const diffYear2 = diff.getUTCFullYear() - 1970;
        const diffMonth2 = diff.getUTCMonth();
        const diffDays2 = diff.getUTCDay();

        if (diffYear2 === 0) {
            if (diffMonth2 === 1) {
                output = diffDays2 + ' days';
            } else {
                output = diffMonth2 + ' months, ' + diffDays2 + ' days';
            }
        }
        else if (diffYear2 === 1) {
            if (diffMonth2 === 0) {
                output = diffYear2 + ' year';
            }
            else if (diffMonth2 === 1) {
                output = diffYear2 + ' year, ' + diffMonth2 + ' month, ' + diffDays2 + ' days';
            } else {
                output = diffYear2 + ' year, ' + diffMonth2 + ' months, ' + diffDays2 + ' days';
            }
        }
        else {
            if (diffMonth2 === 0) {
                output = diffYear2 + ' years';
            }
            else if (diffMonth2 === 1) {
                output = diffYear2 + ' years, ' + diffMonth2 + ' month, ' + diffDays2 + ' days';
            } else {
                output = diffYear2 + ' years, ' + diffMonth2 + ' months, ' + diffDays2 + ' days';
            }
        }
    } else {

    }

    // Console logging
    if (logToConsole) {
        console.log(
            '%c formatDaysRemaining', 'font-weight: bold; color: none',
            '\n' + ' - finish.typeof:', typeof finish,
            '\n' + ' - config.typeof:', typeof config,
            '\n' + ' - output.typeof:', typeof output + '\n',
            { finish },
            { config },
            { output }
        );
    }

    return output;
}

export const formatNumber = (input, config) => {

    // Console logging flag
    const logToConsole = false;

    // *************** CONFIG OPTIONS ***************
    // abbreviate(boolean) : true | false : default = false
    // addSeparators(boolean) : true | false : default = false
    // currency(boolean) : true | false : default = false
    // decimals(integer) : default = 0
    // default(string) :
    // fixDecimals(boolean) : true | false : default = false
    // round(boolean) : true | false : default = false
    // negativeInParentheses(boolean) : true | false : default = true
    // positiveWithPlus(boolean) : true | false : default = false
    // **********************************************

    // DEFAULTS
    let decimals, abbreviate, round, addSeparators, currency, negativeInParentheses, positiveWithPlus;
    if (config instanceof Object) {
        decimals = typeof config.decimals === 'number' ? config.decimals : 0;
        abbreviate = typeof config.abbreviate === 'boolean' ? config.abbreviate : false;
        round = typeof config.round === 'boolean' ? config.round : false;
        addSeparators = typeof config.addSeparators === 'boolean' ? config.addSeparators : false;
        currency = typeof config.currency === 'boolean' ? config.currency : false;
        negativeInParentheses = typeof config.negativeInParentheses === 'boolean' ? config.negativeInParentheses : true;
        positiveWithPlus = typeof config.positiveWithPlus === 'boolean' ? config.positiveWithPlus : false;
    } else {
        decimals = 0;
        abbreviate = false;
        round = false;
        addSeparators = false;
        currency = false;
        negativeInParentheses = true;
        positiveWithPlus = false;
    }

    let output = input;
    let abbreviatedSuffix = "";
    // Default
    if (typeof input !== 'number') {
        if (config.default) {
            output = config.default
        } else {
            // console.log(' > If not a number, what is it: ', input);
            output = "--";
        }
    }
    else {

        // Decimals
        // console.log(' > Decimals: {0}'.format(decimals));

        // NOTE: Order of operations: if both round and abbreviate are true,
        // should the rounding happen after abbreviate?
        // if (currency) {
        //     let test =
        // }

        // Abbreviate
        // let abbreviatedSuffix = "";
        if (abbreviate) {
            // Negative Billions
            if (input <= -1000000000 && input >= -999999999999) {
                output = input / 1000000000;
                abbreviatedSuffix = 'B';
            }
            // Negative Millions
            else if (input <= -1000000 && input >= -999999999) {
                output = input / 1000000;
                abbreviatedSuffix = 'M';
            }
            // Negative Thousands
            else if( input <= -1000 && input >= -999999) {
                output = input / 1000;
                abbreviatedSuffix = 'K';
            }
            // Hundreds
            else if (input <= 999) {
                output = input;
                abbreviatedSuffix = '';
            }
            // Thousands
            else if (input >= 1000 && input <= 999999) {
                output = input / 1000;
                abbreviatedSuffix = 'K';
            }
            // Millions
            else if (input >= 1000000 && input <= 999999999) {
                output = input / 1000000;
                abbreviatedSuffix = 'M';
            }
            // Billions
            else if (input >= 1000000000 && input <= 999999999999) {
                output = input / 1000000000;
                abbreviatedSuffix = 'B';
            }
            else {
                output = input;
                abbreviatedSuffix = '';
            }
            // console.log(' > Abbreviate: {0} ({1}) Suffix: {2}'.format(output, typeof output, abbreviatedSuffix));
        }

        // NOTE: Numbers become strings at this point ...

        // Round
        if (round) {
            output = parseFloat(output.toFixed(decimals));
            // console.log(' > Round: {0} ({1})'.format(output, typeof output));
        }

        // Fix Decimals
        if (config.fixDecimals && typeof output === 'number') {
            output = output.toFixed(decimals)
            // console.log(' > Fix Decimals: {0} ({1})'.format(output, typeof output));
        }

        // // Abbreviate
        // if (abbreviate) {
        //     output = '{0}{1}'.format(output, abbreviatedSuffix);
        //     // console.log(' > Abbreviate: {0} ({1})'.format(output, typeof output));
        // }
    }

    // Currency
    if (currency) {

        //console.log(i18n.language);
        //console.log(i18n.getResourceBundle(i18n.language, 'currencysymbol').key);
        let currencysymbol = i18n.getResourceBundle(i18n.language, 'currencysymbol').key

        let value = output;
        value = '{0}'.format(value);
        // console.log(value);
        try {
            value = parseFloat(value);
            if (isNaN(value)){
                //console.log(output);
                // TODO: see if we need to further process string
            } else {
                output = new Intl.NumberFormat(i18n.language, {
                    style: 'currency',
                    currency: currencysymbol,
                    minimumFractionDigits: decimals
                }).format(value);
            }
            //console.log(typeof(output));
            // console.log(new Intl.NumberFormat(i18n.language, {
            //     style: 'currency',
            //     currency: 'USD',
            //     maximumSignificantDigits: 3}).format(output));

        } catch (error) {
            console.log(error);
        }
        // console.log(' > Currency: {0} ({1})'.format(output, typeof output));
    }

    // Separators
    if (addSeparators) {
        // NOTE: How is this different than NumberUtilities.formatThousands()?
        // https://stackoverflow.com/questions/149055/how-can-i-format-numbers-as-dollars-currency-string-in-javascript
        output = output.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        // console.log(' > Add Separators: {0} ({1})'.format(output, 'typeof output'));
    }

    // Moved the abbreviate until after the number is parsed for curren
    // Abbreviate
    if (abbreviate) {
        output = '{0}{1}'.format(output, abbreviatedSuffix);
        // console.log(' > Abbreviate: {0} ({1})'.format(output, typeof output));
    }

    // Negative in Parentheses
    if (negativeInParentheses && input < 0) {
        output = '({0})'.format(output.toString().replace('-', ''));
        // console.log(' > Negative: {0} ({1})'.format(output, typeof output));
    }

    // Positive With Plus
    if (positiveWithPlus && input > 0) {
        output = '{0}{1}'.format('+', output);
        // console.log(' > Positive: {0} ({1})'.format(output, typeof output));
    }

    // Console logging
    if (logToConsole) {
        console.log(
            '%c formatNumber', 'font-weight: bold; color: none',
            '\n' + ' - input.typeof:', typeof input,
            '\n' + ' - config.typeof:', typeof config,
            '\n' + ' - output.typeof:', typeof output + '\n',
            { input },
            { config },
            { output }
        );
    }

    return output;
};

export const formatStyle = (input, config, initVal, condition, returnCssProperties) => {

    // Console logging flag
    const logToConsole = false;

    // TODO: Make output a variable; move logging condition to bottom of function and log output too
    // Console logging
    if (logToConsole) {
        console.log(
            '%c formatStyle', 'font-weight: bold; color: none',
            '\n' + ' - input.typeof:', typeof input,
            '\n' + ' - config.typeof:', typeof config,
            '\n' + ' - initVal.typeof:', typeof initVal,
            '\n' + ' - condition.typeof:', typeof condition,
            '\n' + ' - returnCssProperties.typeof:', typeof returnCssProperties + '\n',
            { input },
            { config },
            { initVal },
            { condition },
            { returnCssProperties }
        );
    }

    // *************** CONFIG OPTIONS ***************

    // **********************************************

    let cssProperties = "";

    if (condition) {
        if (condition.equality !== "") {
            switch(condition.equality) {
                case '=':
                    if (initVal === condition.value) {
                        if (returnCssProperties) {
                            for (let [key, value] of Object.entries(config)) {
                                if (value) {
                                    cssProperties += key + ':' + value + ";"
                                }
                            }
                            return cssProperties;
                        } else {
                            return <div style={config}>{input}</div>;
                        }
                    } else {
                        if (returnCssProperties) {
                            return cssProperties;
                        } else {
                            return input;
                        }
                    }
                case '>':
                    if (initVal > condition.value) {
                        if (returnCssProperties) {
                            for (let [key, value] of Object.entries(config)) {
                                if (value) {
                                    cssProperties += key + ':' + value + ";"
                                }
                            }
                            return cssProperties;
                        } else {
                            return <div style={config}>{input}</div>;
                        }
                    } else {
                        if (returnCssProperties) {
                            return cssProperties;
                        } else {
                            return input;
                        }
                    }
                case '>=':
                    if (initVal >= condition.value) {
                        if (returnCssProperties) {
                            for (let [key, value] of Object.entries(config)) {
                                if (value) {
                                    cssProperties += key + ':' + value + ";"
                                }
                            }
                            return cssProperties;
                        } else {
                            return <div style={config}>{input}</div>;
                        }
                    } else {
                        if (returnCssProperties) {
                            return cssProperties;
                        } else {
                            return input;
                        }
                    }
                case '<':
                    if (initVal < condition.value) {
                        if (returnCssProperties) {
                            for (let [key, value] of Object.entries(config)) {
                                if (value) {
                                    cssProperties += key + ':' + value + ";"
                                }
                            }
                            return cssProperties;
                        } else {
                            return <div style={config}>{input}</div>;
                        }
                    } else {
                        if (returnCssProperties) {
                            return cssProperties;
                        } else {
                            return input;
                        }
                    }
                case '<=':
                    if (initVal <= condition.value) {
                        if (returnCssProperties) {
                            for (let [key, value] of Object.entries(config)) {
                                if (value) {
                                    cssProperties += key + ':' + value + ";"
                                }
                            }
                            return cssProperties;
                        } else {
                            return <div style={config}>{input}</div>;
                        }
                    } else {
                        if (returnCssProperties) {
                            return cssProperties;
                        } else {
                            return input;
                        }
                    }
                case '!=':
                    if (initVal !== condition.value) {
                        if (returnCssProperties) {
                            for (let [key, value] of Object.entries(config)) {
                                if (value) {
                                    cssProperties += key + ':' + value + ";"
                                }
                            }
                            return cssProperties;
                        } else {
                            return <div style={config}>{input}</div>;
                        }

                    } else {
                        if (returnCssProperties) {
                            return cssProperties;
                        } else {
                            return input;
                        }
                    }
                default:
                    if (returnCssProperties) {
                        for (let [key, value] of Object.entries(config)) {
                            if (value) {
                                cssProperties += key + ':' + value + ";"
                            }
                        }
                        return cssProperties;
                    } else {
                        return input;
                    }
            }
        } else {
            if (returnCssProperties) {
                for (let [key, value] of Object.entries(config)) {
                    if (value) {
                        cssProperties += key + ':' + value + ";"
                    }
                }
                return cssProperties;
            } else {
                return <div style={config}>{input}</div>
            }

        }
    } else {
        if (returnCssProperties) {
            for (let [key, value] of Object.entries(config)) {
                if (value) {
                    cssProperties += key + ':' + value + ";"
                }
            }
            return cssProperties;
        } else {
            return <div style={config}>{input}</div>
        }
    }
};

export const formatText = (input, config) => {

    // Console logging flag
    const logToConsole = false;

    // *************** CONFIG OPTIONS ***************
    // case(string) : lower | upper | none : default = NONE
    // default(string) : default = 'No data'
    // **********************************************

    // Set defaults
    let defaultCase, defaultValue;
    if (config instanceof Object) {
        defaultCase = typeof config.case === 'string' ? config.case.toLowerCase() : 'none';
        defaultValue = typeof config.default === 'string' ? config.default : '-';
    } else {
        defaultCase = 'none'
        defaultValue = '-';
    }

    let output = null;

    if (input) {
        const inputAsString = typeof input === 'string' ? input : input.toString();
        // console.log('INPUT AS STRING: {0} ({1})'.format(inputAsString, typeof inputAsString));

        // Case
        if (defaultCase === 'lower') {
            output = inputAsString.toLowerCase();
        } else if (defaultCase === 'upper') {
            output = inputAsString.toUpperCase();
        } else if (defaultCase === 'none') {
            output = inputAsString;
        } else {

        }
    } else {
        output = defaultValue;
    }

    // Console logging
    if (logToConsole) {
        console.log(
            '%c formatText', 'font-weight: bold; color: none',
            '\n' + ' - input.typeof:', typeof input,
            '\n' + ' - config.typeof:', typeof config,
            '\n' + ' - output.typeof:', typeof output + '\n',
            { input },
            { config },
            { output }
        );
    }

    return output;
}

export const formatPrefix = (input, config) => {

    // Console logging flag
    const logToConsole = false;

    // *************** CONFIG OPTIONS ***************
    // default(string) : default = input
    // **********************************************

    // DEFAULTS
    let text;
    if (config instanceof Object) {
        text = typeof config.text === 'string' ? config.text.toString() : '';
        // percent = typeof config.percent === 'boolean' ? config.percent : false;
        // days = typeof config.days === 'boolean' ? config.days : false;
    } else {
        text = '';
        // percent = false;
        // days = false;
    }

    let output = input;

    // Percent
    // if (percent) {
    //     output = '{0}%'.format(input)
    //     // console.log(' > Percent: {0} ({1})'.format(output, typeof output));
    // }

    // Days
    // if (days) {
    //     output = '{0} days'.format(input)
    //     // console.log(' > Days: {0} ({1})'.format(output, typeof output));
    // }

    // Text
    if (text) {
        output = '{0} {1}'.format(text, input)
        // console.log(' > Text: {0} ({1})'.format(output, typeof output));
    }

    // Console logging
    if (logToConsole) {
        console.log(
            '%c formatPrefix', 'font-weight: bold; color: none',
            '\n' + ' - input.typeof:', typeof input,
            '\n' + ' - config.typeof:', typeof config,
            '\n' + ' - output.typeof:', typeof output + '\n',
            { input },
            { config },
            { output }
        );
    }

    return output;
}

export const formatSuffix = (input, config) => {

    // Console logging flag
    const logToConsole = false;

    // *************** CONFIG OPTIONS ***************
    // default(string) : default = input
    // **********************************************

    // DEFAULTS
    let percent, days, text;
    if (config instanceof Object) {
        percent = typeof config.percent === 'boolean' ? config.percent : false;
        days = typeof config.days === 'boolean' ? config.days : false;
        text = typeof config.text === 'string' ? config.text.toString() : '';
    } else {
        percent = false;
        days = false;
        text = '';
    }

    let output = input;

    // Percent
    if (percent) {
        output = '{0}%'.format(input)
        // console.log(' > Percent: {0} ({1})'.format(output, typeof output));
    }

    // Days
    if (days) {
        output = '{0} days'.format(input)
        // console.log(' > Days: {0} ({1})'.format(output, typeof output));
    }

    // Text
    if (text) {
        output = '{0} {1}'.format(input, text)
        // console.log(' > Text: {0} ({1})'.format(output, typeof output));
    }

    // Console logging
    if (logToConsole) {
        console.log(
            '%c formatSuffix', 'font-weight: bold; color: none',
            '\n' + ' - input.typeof:', typeof input,
            '\n' + ' - config.typeof:', typeof config,
            '\n' + ' - output.typeof:', typeof output + '\n',
            { input },
            { config },
            { output }
        );
    }

    return output;
}

export const FormatLink = (input, config) => {

    // Console logging flag
    const logToConsole = false;

    // *************** CONFIG OPTIONS ***************
    // path(string) : uri
    // params(array) : [tab=1]
    // **********************************************

    // Build Relative Path
    const path = config.path.format(input, addParams(config.params)); // tack on the input to {0}, if present

    // https://material-ui.com/guides/composition/
    const output =  <Tooltip title={config.tooltip + ": " + input} arrow placement="top-start">
                        <ListItem button component={NavLink} to={path}>
                            <ListItemIcon><ExitToAppIcon></ExitToAppIcon></ListItemIcon>
                        </ListItem>
                    </Tooltip>

    // Console logging
    if (logToConsole) {
        console.log(
            '%c FormatLink', 'font-weight: bold; color: none',
            '\n' + ' - input.typeof:', typeof input,
            '\n' + ' - config.typeof:', typeof config,
            '\n' + ' - output.typeof:', typeof output + '\n',
            { input },
            { config },
            { output }
        );
    }

    return output;
}

export const formatLink2 = (input, config) => {

    // Console logging flag
    const logToConsole = false;

    // *************** CONFIG OPTIONS ***************
    // case(string) : lower | upper | none : default = NONE
    // default(string) : default = 'No data'
    // **********************************************

    let type;
    // Set defaults
    if (config instanceof Object) {
        type = typeof config.type === 'string' ? config.type.toLowerCase() : '';
    } else {
        type = ''
    }

    let output = '';
    let hasLeadingSlash = false;
    let path = '';
    if (input) {

        // Build Relative Path
        if (config?.path !== undefined) {
            input = config.path.format(input, addParams(config.params)); // tack on the input to {0}, if present
        }

        switch(type.toLowerCase()) {
            case 'file':
                output = 'file://:' + input;
                break;
            case 'ftp':
                output = 'ftp://:' + input;
                break;
            case 'mailto':
                output = 'mailto:' + input;
                // output = {0}{1}.format('mailto:', input);
                break;
            case 'tel':
                output = 'tel:' + input;
                break;
            case 'http':
                output = input;
                break;
            case 'internal':
                output = input;
                break;
            default:
                hasLeadingSlash = input.startsWith('/');  // Check initial slash because axiosBaseURL has trailing slash
                output =  axiosBaseURL() + (hasLeadingSlash === true ? input.substring(1,input.length) : path);
        }

    } else {
        // output = defaultValue;
    }

    // Console logging
    if (logToConsole) {
        console.log(
            '%c formatLink2', 'font-weight: bold; color: none',
            '\n' + ' - input.typeof:', typeof input,
            '\n' + ' - config.typeof:', typeof config,
            '\n' + ' - output.typeof:', typeof output + '\n',
            { input },
            { config },
            { output }
        );
    }

    return output;
}

const addParams = (params) => {

    // Console logging flag
    const logToConsole = false;

    let paramString = '';
    params.forEach( p => paramString += '/' + p);

    // Console logging
    if (logToConsole) {
        console.log(
            '%c addParams', 'font-weight: bold; color: none',
            '\n' + ' - params.typeof:', typeof params,
            '\n' + ' - paramString.typeof:', typeof paramString + '\n',
            { params },
            { paramString }
        );
    }

    return paramString;
}

export const FormatModalLink = (input, config) => {
	const dispatch = useDispatch();

	const [icon, setIcon] = useState(<React.Fragment />);

	// Console logging flag
    const logToConsole = false;

    // TODO: Make output a variable; move logging condition to bottom of function and log output too
    // Console logging
    if (logToConsole) {
        console.log(
            '%c FormatModalLink', 'font-weight: bold; color: none',
            '\n' + ' - input.typeof:', typeof input,
            '\n' + ' - config.typeof:', typeof config + '\n',
            { input },
            { config }
        );
    }

	useEffect(() => {
		// Set Icon
		if (config.type.toLowerCase() === 'edit') {
			setIcon(<EditIcon></EditIcon>);
		} else if (config.type.toLowerCase() === 'person') {
			setIcon(<Person></Person>);
		} else {
			setIcon(<InfoIcon></InfoIcon>)
		}
	},[])


	const displayModal = (config) => {
        const modal = config.configuration;
        const filter = config.filterOnClick;
		let filterValue = {};

        if (filter.enabled === true) {
            // -412 represents a filter applied for a click that produces a Modal
            // -412 filter for modal will be removed on Modal.js --> handleClose()
            if (filter.filterOperator.toLowerCase() === 'like') {
                dispatch(dataAddFilter('-412', filter.filterField, " like '%{0}%'".format(input), filterUpdateConditionAction.REPLACE, true, false));
            } else {
                dispatch(dataAddFilter('-412', filter.filterField, " eq '{0}'".format(input), filterUpdateConditionAction.REPLACE, true, false));
            }

			filterValue = {filterValue: input !== undefined ? input : null}
        }

        const modalConfig = {
            title: modal.wrapper.title,
            parent: modal.wrapper.parent,
            paper: modal.wrapper.paper,
            button: modal.wrapper.button,
            content: <DynamicContainerLayout configuration={modal}/>,
            tooltipContent: '', //modal.tooltip
			...filterValue
        }
        // console.log(modalConfig);

        dispatch(appSetModalContent(modalConfig));
    }

    return (
        <Tooltip title={config.linkTooltip + ": " + input} arrow placement="top-start">
            <ListItem button onClick={ () => displayModal(config)}>
                <ListItemIcon>
					{icon}
				</ListItemIcon>
            </ListItem>
        </Tooltip>
    );
}

export const formatGoodBad = (input, config, initVal, condition, returnCssProperties) => {

    // Console logging flag
    const logToConsole = false;

    // TODO: Make output a variable; move logging condition to bottom of function and log output too
    // Console logging
    if (logToConsole) {
        console.log(
            '%c formatGoodBad', 'font-weight: bold; color: none',
            '\n' + ' - input.typeof:', typeof input,
            '\n' + ' - config.typeof:', typeof config,
            '\n' + ' - initVal.typeof:', typeof initVal,
            '\n' + ' - condition.typeof:', typeof condition,
            '\n' + ' - returnCssProperties.typeof:', typeof returnCssProperties + '\n',
            { input },
            { config },
            { initVal },
            { condition },
            { returnCssProperties },
        );
    }

    // *************** CONFIG OPTIONS ***************

    // **********************************************

    let cssProperties = "";

    if (condition) {
        if (condition.equality !== "") {
            switch(condition.equality) {
                case '=':
                    if (initVal === condition.value) {
                        if (returnCssProperties) {
                            for (let [key, value] of Object.entries(config)) {
                                if (value) {
                                    cssProperties += key + ':' + value + ";"
                                }
                            }
                            return cssProperties;
                        } else {
                            // <Avatar style={{float: 'left', marginTop: '1px', marginRight: '5px', width: '16px', height: '16px', color: '#fff',backgroundColor: 'green'}}>
                            //     <CheckCircleIcon style={{width: '16px', height: '16px'}}/>
                            // </Avatar>
                            return "<div style='display: inline-flex;'><div><svg style=\"float: left; margin-top: 12px; margin-right: 5px; border-radius: 50%;\" height=\"16\" width=\"16\" viewBox=\"0 0 24 24\" focusable=\"false\" aria-hidden=\"true\"><path d=\"M0 0h24v24H0z\" fill=\"green\"/><path fill=\"rgb(255, 255, 255)\" d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z\"/></svg></div>" + input + "</div>"
                        }
                    } else {
                        if (returnCssProperties) {
                            return cssProperties;
                        } else {
                            // <Avatar style={{float: 'left', marginTop: '1px', marginRight: '5px', width: '16px', height: '16px', color: '#fff',backgroundColor: 'red'}}>
                            //     <ReportIcon style={{width: '16px', height: '16px'}}/>
                            // </Avatar>
                            return "<div style='display: inline-flex;'><div><svg style=\"float: left; margin-top: 12px; margin-right: 5px; border-radius: 50%;\" height=\"16\" width=\"16\" viewBox=\"0 0 24 24\" focusable=\"false\" aria-hidden=\"true\"><path fill=\"red\" d=\"M0 0h24v24H0z\"/><path fill=\"rgb(255, 255, 255)\" d=\"M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM12 17.3c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3zm1-4.3h-2V7h2v6z\"/></svg></div>" + input + "</div>"
                        }
                    }
                case '>':
                    if (initVal > condition.value) {
                        if (returnCssProperties) {
                            for (let [key, value] of Object.entries(config)) {
                                if (value) {
                                    cssProperties += key + ':' + value + ";"
                                }
                            }
                            return cssProperties;
                        } else {
                            // <Avatar style={{float: 'left', marginTop: '1px', marginRight: '5px', width: '16px', height: '16px', color: '#fff',backgroundColor: 'green'}}>
                            //     <CheckCircleIcon style={{width: '16px', height: '16px'}}/>
                            // </Avatar>
                            return "<div style='display: inline-flex;'><div><svg style=\"float: left; margin-top: 12px; margin-right: 5px; border-radius: 50%;\" height=\"16\" width=\"16\" viewBox=\"0 0 24 24\" focusable=\"false\" aria-hidden=\"true\"><path d=\"M0 0h24v24H0z\" fill=\"green\"/><path fill=\"rgb(255, 255, 255)\" d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z\"/></svg></div>" + input + "</div>"
                        }
                    } else {
                        if (returnCssProperties) {
                            return cssProperties;
                        } else {
                            // <Avatar style={{float: 'left', marginTop: '1px', marginRight: '5px', width: '16px', height: '16px', color: '#fff',backgroundColor: 'red'}}>
                            //     <ReportIcon style={{width: '16px', height: '16px'}}/>
                            // </Avatar>
                            return "<div style='display: inline-flex;'><div><svg style=\"float: left; margin-top: 12px; margin-right: 5px; border-radius: 50%;\" height=\"16\" width=\"16\" viewBox=\"0 0 24 24\" focusable=\"false\" aria-hidden=\"true\"><path fill=\"red\" d=\"M0 0h24v24H0z\"/><path fill=\"rgb(255, 255, 255)\" d=\"M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM12 17.3c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3zm1-4.3h-2V7h2v6z\"/></svg></div>" + input + "</div>"
                        }
                    }
                case '>=':
                    if (initVal >= condition.value) {
                        if (returnCssProperties) {
                            for (let [key, value] of Object.entries(config)) {
                                if (value) {
                                    cssProperties += key + ':' + value + ";"
                                }
                            }
                            return cssProperties;
                        } else {
                            // <Avatar style={{float: 'left', marginTop: '1px', marginRight: '5px', width: '16px', height: '16px', color: '#fff',backgroundColor: 'green'}}>
                            //     <CheckCircleIcon style={{width: '16px', height: '16px'}}/>
                            // </Avatar>
                            return "<div style='display: inline-flex;'><div><svg style=\"float: left; margin-top: 12px; margin-right: 5px; border-radius: 50%;\" height=\"16\" width=\"16\" viewBox=\"0 0 24 24\" focusable=\"false\" aria-hidden=\"true\"><path d=\"M0 0h24v24H0z\" fill=\"green\"/><path fill=\"rgb(255, 255, 255)\" d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z\"/></svg></div>" + input + "</div>"
                        }
                    } else {
                        if (returnCssProperties) {
                            return cssProperties;
                        } else {
                            // <Avatar style={{float: 'left', marginTop: '1px', marginRight: '5px', width: '16px', height: '16px', color: '#fff',backgroundColor: 'red'}}>
                            //     <ReportIcon style={{width: '16px', height: '16px'}}/>
                            // </Avatar>
                            return "<div style='display: inline-flex;'><div><svg style=\"float: left; margin-top: 12px; margin-right: 5px; border-radius: 50%;\" height=\"16\" width=\"16\" viewBox=\"0 0 24 24\" focusable=\"false\" aria-hidden=\"true\"><path fill=\"red\" d=\"M0 0h24v24H0z\"/><path fill=\"rgb(255, 255, 255)\" d=\"M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM12 17.3c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3zm1-4.3h-2V7h2v6z\"/></svg></div>" + input + "</div>"
                        }
                    }
                case '<':
                    if (initVal < condition.value) {
                        if (returnCssProperties) {
                            for (let [key, value] of Object.entries(config)) {
                                if (value) {
                                    cssProperties += key + ':' + value + ";"
                                }
                            }
                            return cssProperties;
                        } else {
                            // <Avatar style={{float: 'left', marginTop: '1px', marginRight: '5px', width: '16px', height: '16px', color: '#fff',backgroundColor: 'green'}}>
                            //     <CheckCircleIcon style={{width: '16px', height: '16px'}}/>
                            // </Avatar>
                            return "<div style='display: inline-flex;'><div><svg style=\"float: left; margin-top: 12px; margin-right: 5px; border-radius: 50%;\" height=\"16\" width=\"16\" viewBox=\"0 0 24 24\" focusable=\"false\" aria-hidden=\"true\"><path d=\"M0 0h24v24H0z\" fill=\"green\"/><path fill=\"rgb(255, 255, 255)\" d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z\"/></svg></div>" + input + "</div>"
                        }
                    } else {
                        if (returnCssProperties) {
                            return cssProperties;
                        } else {
                            // <Avatar style={{float: 'left', marginTop: '1px', marginRight: '5px', width: '16px', height: '16px', color: '#fff',backgroundColor: 'red'}}>
                            //     <ReportIcon style={{width: '16px', height: '16px'}}/>
                            // </Avatar>
                            return "<div style='display: inline-flex;'><div><svg style=\"float: left; margin-top: 12px; margin-right: 5px; border-radius: 50%;\" height=\"16\" width=\"16\" viewBox=\"0 0 24 24\" focusable=\"false\" aria-hidden=\"true\"><path fill=\"red\" d=\"M0 0h24v24H0z\"/><path fill=\"rgb(255, 255, 255)\" d=\"M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM12 17.3c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3zm1-4.3h-2V7h2v6z\"/></svg></div>" + input + "</div>"
                        }
                    }
                case '<=':
                    if (initVal <= condition.value) {
                        if (returnCssProperties) {
                            for (let [key, value] of Object.entries(config)) {
                                if (value) {
                                    cssProperties += key + ':' + value + ";"
                                }
                            }
                            return cssProperties;
                        } else {
                            // <Avatar style={{float: 'left', marginTop: '1px', marginRight: '5px', width: '16px', height: '16px', color: '#fff',backgroundColor: 'green'}}>
                            //     <CheckCircleIcon style={{width: '16px', height: '16px'}}/>
                            // </Avatar>
                            return "<div style='display: inline-flex;'><div><svg style=\"float: left; margin-top: 12px; margin-right: 5px; border-radius: 50%;\" height=\"16\" width=\"16\" viewBox=\"0 0 24 24\" focusable=\"false\" aria-hidden=\"true\"><path d=\"M0 0h24v24H0z\" fill=\"green\"/><path fill=\"rgb(255, 255, 255)\" d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z\"/></svg></div>" + input + "</div>"
                        }
                    } else {
                        if (returnCssProperties) {
                            return cssProperties;
                        } else {
                            // <Avatar style={{float: 'left', marginTop: '1px', marginRight: '5px', width: '16px', height: '16px', color: '#fff',backgroundColor: 'red'}}>
                            //     <ReportIcon style={{width: '16px', height: '16px'}}/>
                            // </Avatar>
                            return "<div style='display: inline-flex;'><div><svg style=\"float: left; margin-top: 12px; margin-right: 5px; border-radius: 50%;\" height=\"16\" width=\"16\" viewBox=\"0 0 24 24\" focusable=\"false\" aria-hidden=\"true\"><path fill=\"red\" d=\"M0 0h24v24H0z\"/><path fill=\"rgb(255, 255, 255)\" d=\"M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM12 17.3c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3zm1-4.3h-2V7h2v6z\"/></svg></div>" + input + "</div>"
                        }
                    }
                case '!=':
                    if (initVal !== condition.value) {
                        if (returnCssProperties) {
                            for (let [key, value] of Object.entries(config)) {
                                if (value) {
                                    cssProperties += key + ':' + value + ";"
                                }
                            }
                            return cssProperties;
                        } else {
                            // <Avatar style={{float: 'left', marginTop: '1px', marginRight: '5px', width: '16px', height: '16px', color: '#fff',backgroundColor: 'green'}}>
                            //     <CheckCircleIcon style={{width: '16px', height: '16px'}}/>
                            // </Avatar>
                            return "<div style='display: inline-flex;'><div><svg style=\"float: left; margin-top: 12px; margin-right: 5px; border-radius: 50%;\" height=\"16\" width=\"16\" viewBox=\"0 0 24 24\" focusable=\"false\" aria-hidden=\"true\"><path d=\"M0 0h24v24H0z\" fill=\"green\"/><path fill=\"rgb(255, 255, 255)\" d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z\"/></svg></div>" + input + "</div>"
                        }

                    } else {
                        if (returnCssProperties) {
                            return cssProperties;
                        } else {
                            // <Avatar style={{float: 'left', marginTop: '1px', marginRight: '5px', width: '16px', height: '16px', color: '#fff',backgroundColor: 'red'}}>
                            //     <ReportIcon style={{width: '16px', height: '16px'}}/>
                            // </Avatar>
                            return "<div style='display: inline-flex;'><div><svg style=\"float: left; margin-top: 12px; margin-right: 5px; border-radius: 50%;\" height=\"16\" width=\"16\" viewBox=\"0 0 24 24\" focusable=\"false\" aria-hidden=\"true\"><path fill=\"red\" d=\"M0 0h24v24H0z\"/><path fill=\"rgb(255, 255, 255)\" d=\"M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM12 17.3c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3zm1-4.3h-2V7h2v6z\"/></svg></div>" + input + "</div>"
                        }
                    }
                default:
                    if (returnCssProperties) {
                        for (let [key, value] of Object.entries(config)) {
                            if (value) {
                                cssProperties += key + ':' + value + ";"
                            }
                        }
                        return cssProperties;
                    } else {
                        return input;
                    }
            }
        } else {
            if (returnCssProperties) {
                for (let [key, value] of Object.entries(config)) {
                    if (value) {
                        cssProperties += key + ':' + value + ";"
                    }
                }
                return cssProperties;
            } else {
                return <div style={config}>{input}</div>
            }

        }
    } else {
        if (returnCssProperties) {
            for (let [key, value] of Object.entries(config)) {
                if (value) {
                    cssProperties += key + ':' + value + ";"
                }
            }
            return cssProperties;
        } else {
            return <div style={config}>{input}</div>
        }
    }
};

export function formatValue(value, formatters, overrides, returnCssProperties) {

    // Console logging flag
    const logToConsole = false;

    const formattersToApply = overrides && overrides.length ? overrides : formatters;
    let formattedValue = value;

    if (formattersToApply) {
        for (const formatter of formattersToApply) {
            if (formatter.type.toLowerCase() === 'date') {
                formattedValue = formatDate(formattedValue, formatter.config)
            } else if (formatter.type.toLowerCase() === 'link2') {
                formattedValue = formatLink2(formattedValue, formatter.config);
            } else if (formatter.type.toLowerCase() === 'number') {
                formattedValue = formatNumber(formattedValue, formatter.config);
            } else if (formatter.type.toLowerCase() === 'style') {
                formattedValue = formatStyle(formattedValue, formatter.config, value, formatter.condition, returnCssProperties);
            } else if (formatter.type.toLowerCase() === 'text') {
                formattedValue = formatText(formattedValue, formatter.config);
            } else if (formatter.type.toLowerCase() === 'suffix') {
                formattedValue = formatSuffix(formattedValue, formatter.config);
            } else {
                // Something else
            }
        }
    }

    // Console logging
    if (logToConsole) {
        console.log(
            '%c formatValue', 'font-weight: bold; color: none',
            '\n' + ' - value.typeof:', typeof value,
            '\n' + ' - formatters.typeof:', typeof formatters,
            '\n' + ' - overrides.typeof:', typeof overrides,
            '\n' + ' - returnCssProperties.typeof:', typeof returnCssProperties,
            '\n' + ' - formattedValue.typeof:', typeof formattedValue + '\n',
            { value },
            { formatters },
            { overrides },
            { returnCssProperties },
            { formattedValue }
        );
    }

    return formattedValue;
}

export const formatTypographyColor = (input) => {

    // Console logging flag
    const logToConsole = false;

    let componentColor = 'inherit';
    let styleColor = '';

    if (input === 'initial' || input === 'inherit' || input === 'primary' ||
        input === 'secondary' || input === 'textPrimary' || input === 'textSecondary' || input === 'error') {

        // console.log('Valid Material UI typography color property');
        componentColor = input;
    } else if (input.startsWith('#') && input.length === 7) {

        // console.log('Valid HEX code');
        styleColor = input;
    } else {

        // console.log('Neither a valid Material UI typography color property or a HEX code');
        componentColor = 'initial';
    }

    const output = {component: componentColor, style: styleColor}

    // Console logging
    if (logToConsole) {
        console.log(
            '%c formatTypographyColor', 'font-weight: bold; color: none',
            '\n' + ' - input.typeof:', typeof input,
            '\n' + ' - input.length:', input.length,
            '\n' + ' - input.startsWith(#):', input.startsWith('#'),
            '\n' + ' - output.typeof:', typeof output + '\n',
            { input },
            { output }
        );
    }

    return output;
}
